module.exports = __webpack_public_path__ + "files/8edadf10dc508c1c1d7b7ab367a15ba1.png";